(ns app.domain.cloudcheck.model
  (:require [core.db.child-entity :as child]))

(def run-states
  #{:cloudcheck-run.state/running
    :cloudcheck-run.state/error
    :cloudcheck-run.state/finished})

(def run-types
  #{:cloudcheck-run.type/precheck
    :cloudcheck-run.type/postcheck})

(def finding-types
  #{:cloudcheck-finding.type/potential-issue
    :cloudcheck-finding.type/missing-evidence
    :cloudcheck-finding.type/uncertain})

(def ^{:arglists '([phase])} runs
  (child/child-entities-of-type-fn :entity.type/cloudcheck-run))

(defn latest-postcheck-run [phase]
  (->> (runs phase)
       (filter #(= :cloudcheck-run.type/postcheck (:cloudcheck-run/type %)))
       (sort-by (juxt :entity/created :db/id))
       last))

(def ^{:arglists '([run])} findings
  (comp (partial sort-by :db/id)
        (child/child-entities-of-type-fn :entity.type/cloudcheck-finding)))

(def ^{:arglists '([finding])} evidence
  (comp (partial sort-by :db/id)
        (child/child-entities-of-type-fn :entity.type/cloudcheck-finding-evidence)))
